import React from 'react'
import { I18n } from 'react-redux-i18n';
import SelectField from "../../shared/components/fields/selectField/SelectField";
import Alert from '../../shared/components/alerts/Alert';
import FormButtons from "../../shared/components/others/formButtons/FormButtons";
import EntityGeneralForm from "./fields/EntityGeneralForm"
import {availableEntityTypes} from "../../../smartBuildings/otherEntities/utils";
import EntityTypeSubForm from "../../../smartBuildings/otherEntities/components/EntityTypeSubForm";
import { appModules } from '../../roles/components/UserHasPermission';
import EntityInterfacesPageContainer from "../../entityInterfaces/containers/EntityInterfacesPageContainer";

const EntitiesForm = ({
    entityFormData: {
        name,
        type,
        parent,
        subFormData = {}
    },
    alert,
    editMode,
    createMode,
    viewMode,
    entityList,
    providerList,
    handleFieldChange,
    handleSubFormFieldChange,
    handleOnFieldBlur,
    handleSubmitClick,
    handleImageUploaded,
    handleWrongImageFormat,
    handleBackClick,
    handleEditClick,
    handleDeleteClick,
    entityId,
    history
}) => {
    return <div className="form-container">
        <div className="form">
            <Alert
                {...alert}
            />
            <div className="header">
                {buildHeader(createMode, editMode, viewMode)}
            </div>
            <div className="fields">
                <div id="user-fields-1" className="field-row">
                    <div className="row">
                        <SelectField
                            value={type.value}
                            label={I18n.t("entities.form.type.label")}
                            disabled={viewMode || editMode}
                            handleFieldChange={value => handleFieldChange("type", value)}
                            options={[
                                { value: availableEntityTypes.region, label: I18n.t("entities.types.region") },
                                { value: availableEntityTypes.company, label: I18n.t("entities.types.company") },
                                { value: availableEntityTypes.building, label: I18n.t("entities.types.building") },
                                { value: availableEntityTypes.floor, label: I18n.t("entities.types.floor") },
                                { value: availableEntityTypes.openSpace, label: I18n.t("entities.types.openSpace") },
                                { value: availableEntityTypes.meetingRoom, label: I18n.t("entities.types.meetingRoom") }
                            ]}
                            error={type.error}
                            width={4}
                        />
                    </div>
                </div>
                <EntityGeneralForm
                    name={name}
                    parent={parent}
                    viewMode={viewMode}
                    editMode={editMode}
                    createMode={createMode}
                    entityList={entityList}
                    handleOnFieldBlur={handleOnFieldBlur}
                    handleFieldChange={handleFieldChange}
                />
                <EntityTypeSubForm
                    entityType={type.value}
                    subFormData={subFormData}
                    providerList={providerList}
                    viewMode={viewMode}
                    editMode={editMode}
                    createMode={createMode}
                    handleFieldChange={handleSubFormFieldChange}
                    handleImageUploaded={handleImageUploaded}
                    handleWrongImageFormat={handleWrongImageFormat}
                />

                {!editMode && !createMode &&
                    <div>
                        <div className={"entity-form-interface-box-header"}>
                            {I18n.t("entities.form.headers.entityInterfaces")}
                        </div>
                        <EntityInterfacesPageContainer
                            externalPageSize={3}
                            suppressSearchForm={false}
                            entityId={entityId}
                            history={history}
                        />
                    </div>
                }

            </div>
            {(createMode || editMode) &&
            <div className="buttons">
                <button
                    className=" mt-3 btn btn-primary"
                    onClick={handleSubmitClick}
                >
                    {I18n.t("forms.save")}
                </button>
            </div>
            }
        </div>
        <div className="form-options">
            <FormButtons
                editMode={editMode}
                viewMode={viewMode}
                handleBackClick={handleBackClick}
                handleEditClick={handleEditClick}
                handleDeleteClick={handleDeleteClick}
                appModule={appModules.ENTITY}
            />
        </div>
    </div>
};

function buildHeader(createMode, editMode) {
    return createMode ?
        I18n.t("entities.form.headers.create") :
        editMode ?
            I18n.t("entities.form.headers.edit") :
            I18n.t("entities.form.headers.view");
}

export default EntitiesForm;